import {
  applyMiddleware,
  compose,
  createStore as createReduxStore
} from 'redux'
import { thunk } from 'redux-thunk'
import { history } from 'navigation'
import createRootReducer from './reducers'
import { updateLocation } from './location'

const createStore = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []
  let composeEnhancers = compose

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    createRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  )
  store.asyncReducers = {}

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  store.unsubscribeHistory = history.listen(updateLocation(store))

  // Hot Module Replacement for reducers using ES module hot API
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => {
      import('./reducers').then(({ default: reducers }) => {
        store.replaceReducer(reducers(store.asyncReducers))
      })
    })
  }

  return store
}

export default createStore
